export const maxImageFileSize = 10485760;